import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { selectCourseProgress } from "../../../redux/personaliseLessons/moduleProgressSlice";

const BottomStickyBar = ({ isAtEnd, handleNavigation }) => {
  const courseProgress = useSelector(selectCourseProgress)?.progress;

  const newLearners = useCallback(() => {
    const time = new Date();
    const hours = time.getHours();
    const minutes = time.getMinutes();
    let maxLearners =
      hours.toString() +
      (minutes < 9 ? "0" + minutes.toString() : minutes.toString());
    return Math.max(parseInt(maxLearners) + 9, 171);
  }, []);

  return (
    <>
      <div
        className={`fixed bottom-0 left-0 z-50 flex w-full justify-between px-2 py-3 text-center md:left-1/2 md:-translate-x-[50%] md:px-6  ${
          isAtEnd ? "hidden" : "bg-[#26588B]"
        }`}
      >
        <div className="ml-2 flex flex-col items-start">
          <div className="w-[96px]">
            <img
              src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_7460.png?updatedAt=1685799750611"
              alt=""
              className="h- w-full"
            />
          </div>
          <p className="mt-0.5 text-xs">
            {newLearners()} LearnTubeX Upgrades Today
          </p>
        </div>
        <div className="mt-1">
          <div
            className="btn--glow cursor-pointer rounded-lg bg-[#7FC241] px-3 py-2 text-sm font-semibold"
            onClick={handleNavigation}
          >
            {courseProgress === 0
              ? "Start Learning"
              : courseProgress === 100
              ? "Completed"
              : "Continue Learning"}
          </div>
        </div>
      </div>
    </>
  );
};

export default BottomStickyBar;
